import React from 'react'
import reactCSS from 'reactcss'

export const ColorPickerPointerCircle = () => {
    const styles = reactCSS({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '10px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-10px, -10px)',
            },
        },
    })

    return (
        <div style={ styles.picker } />
    )
};

export default ColorPickerPointerCircle



// WEBPACK FOOTER //
// ./src/components/recoloring/ColorPickerPointerCircle.js